<template lang="pug">
    section#banner
        .wrapper
            div.conteudo
                h1 Compromisso Fael
                    img(:src="require('@images/logo/compromissoFael.png')", alt="Compromisso Fael")
                p
                    |A FAEL tem um compromisso com o aluno, 
                    |com a educação e com o futuro! A partir da 
                    |oferta de novas experiências e vivências 
                    |para o aluno FAEL, podemos transformá-lo 
                    |sempre para melhor, como pessoa e como 
                    |profissional. Conheça nossos programas!
            div.img
                img(:src="require('@images/others/lady.png')")
</template>

<script>
export default {
    name: "banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>